import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

function MobileCourseDisclosure({
  title,
  children,
  defaultOpen = false,
  titleClassName = 'font-rocky-extra-light text-4xl italic text-primary',
  desktopClassName = '',
}) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <>
      <div className={`hidden md:block ${desktopClassName}`}>
        {children}
      </div>

      <div className="md:hidden">
        <button
          type="button"
          onClick={() => setIsOpen((current) => !current)}
          className="flex w-full items-center justify-between gap-4 text-left"
          aria-expanded={isOpen}
        >
          <span className={titleClassName}>{title}</span>
          <ChevronDown className={`h-7 w-7 shrink-0 text-primary transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
        </button>
        <div className={`grid transition-all duration-500 ease-in-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
          <div className="overflow-hidden">
            <div className="pt-5">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MobileCourseDisclosure;
